import { EXPIRED_SESSION_KEY } from '../constants/expiredSessionKey';

export const disableExpiredSessionBanner = () => window.sessionStorage.setItem(EXPIRED_SESSION_KEY, '');
